import { useState, useRef, useEffect } from 'react';
import { Box, IconButton } from '@mui/joy';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data/sets/14/facebook.json';
import { EmojiDisplay } from './EmojiDisplay';
import { useCustomEmojis } from '@/hooks/useCustomEmojis';

export function EmojiPickerButton({ emoji, onEmojiSelect, disabled = false, size = 'sm' }) {
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showPicker]);

  const { customEmojis } = useCustomEmojis();

  return (
    <Box sx={{ position: 'relative', opacity: disabled ? 0.6 : 1 }}>
      <IconButton
        size={size}
        variant="outlined"
        onClick={() => setShowPicker(!showPicker)}
        disabled={disabled}
      >
        <EmojiDisplay emoji={emoji || 'grinning'} size={20} />
      </IconButton>
      {showPicker && (
        <Box
          ref={pickerRef}
          sx={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1000,
            mt: 1,            
          }}
        >
          <Picker            
            data={data}            
            onEmojiSelect={(emojiData) => {
              onEmojiSelect(emojiData.id);
              setShowPicker(false);
            }}
            set="facebook"
            theme="light"
            previewPosition="none"
            skinTonePosition="none"           
            custom={customEmojis} 
          />
        </Box>
      )}
    </Box>
  );
}

